var _g, _rect, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleAgreement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 84,
    viewBox: "0 0 113 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9577_41069)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.6562,
    y: 26.3438,
    width: 1,
    height: 17,
    transform: "rotate(-45 25.6562 26.3438)",
    fill: "#5D38F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.3633,
    y: 38.3633,
    width: 1,
    height: 17,
    transform: "rotate(-135 26.3633 38.3633)",
    fill: "#5D38F7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#5D38F7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9577_41069)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.6562,
    y: 46.3438,
    width: 1,
    height: 17,
    transform: "rotate(-45 74.6562 46.3438)",
    fill: "#5D38F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.3633,
    y: 58.3633,
    width: 1,
    height: 17,
    transform: "rotate(-135 75.3633 58.3633)",
    fill: "#5D38F7"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 20.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#5D38F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9577_41069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9577_41069"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 20,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleAgreement);
export default __webpack_public_path__ + "static/media/double_agreement.c79e1c9e927e70767a93ad341bd29346.svg";
export { ForwardRef as ReactComponent };